import { mapLinkableEntityType } from '@api';
import type { BirthdayEventType as ApiBirthdayEventType } from 'src/api/generated/touring/types';
import { mapBirthdate } from '../../../common';
import type { BirthdayEventType } from '../../types';

export const mapBirthdayEventType = (
  api: ApiBirthdayEventType
): BirthdayEventType => ({
  person: mapLinkableEntityType(api.person),
  birthdate: mapBirthdate(api.birthdate),
});
